import {useMemo} from "react";
import {useSelector} from "react-redux";
import _ from "lodash";
import {buildCustomFields, isCustomFieldSupported} from "../CustomFieldUtils";
import {useParams} from "react-router-dom";
import {getPlatform, PLATFORM} from "../../../../../../Messages/MessageDetails/Utilities/MessageDetailsUtils";

export default function () {
    let customFieldList = useSelector(state => state.customField.messageCustomFields);
    customFieldList = _.get(customFieldList, 'customFields') || [];
    const loadingCustomFields = useSelector(state => state.customField.listMessageCustomFieldsLoading);
    const originalConversation = useSelector(state => state.fullEmailConversation.emailConversationData);
    const conversationCustomFields = _.get(originalConversation, 'emailConversation.0.customFields') || [];
    const loadingOriginalConversation = useSelector(state => state.fullEmailConversation.loadingEmailConversation);
    const params = useParams();
    const messageId = _.get(params, 'id');
    const platform = getPlatform(messageId);
    let message = {};
    let loadingMessage;

    if (platform === PLATFORM.TEAMS) {
        message = useSelector(state => state.messages.teamsMessage);
        loadingMessage = useSelector(state => state.messages.loadingTeamsMessage);
    } else if (platform === PLATFORM.TRENDS) {
        message = useSelector(state => state.messages.trendsMessage);
        loadingMessage = useSelector(state => state.messages.loadingTrendsMessage);
    } else if (platform === PLATFORM.VOTE) {
        message = useSelector(state => state.messages.nextMessage);
        loadingMessage = useSelector(state => state.messages.loadingNextMessage);
    }

    const loading = loadingOriginalConversation || loadingCustomFields || loadingMessage;
    const hasCustomFields =
        !_.isEmpty(customFieldList) &&
        !_.isEmpty(conversationCustomFields) &&
        !loadingCustomFields &&
        !loadingOriginalConversation;

    const sourceName = _.toString(_.get(message, 'sourceName') || _.get(message, 'msgDataSource.msgSource.name')).toLowerCase();
    const isSupported = isCustomFieldSupported(sourceName);
    const shouldProcess = isSupported && hasCustomFields;

    const customFields = useMemo(() => {
        if(!shouldProcess) {
            return [];
        }
        return buildCustomFields(customFieldList, conversationCustomFields);

    }, [loading, _.get(originalConversation, 'messageId')]) || [];

    return { customFields, loadingCustomFields };
}